import { checkForOverlappingAndOutOfBoundsLabels } from "./checkForOverlappingAndOutOfBoundsLabels";

const MOSAIC_LABEL_SPACING = 0;
export const MOSAIC_GRID_LEFT = 59;
export const MOSAIC_GRID_RIGHT = 20;

export function createColorMap(series) {
  const colorList = {};
  if (Array.isArray(series)) {
    series.forEach((s) => {
      colorList[s.label] = s.style.hexColor;
    });
  }
  return colorList;
}

export function formatSeriesData(series, colorList) {
  const formattedData = series.map((s) => [s.label, s.x[0], s.x[1], s.y[0], s.y[1]]);
  return formattedData.map((item) => ({
    value: item,
    itemStyle: {
      color: colorList[item[0]],
      borderColor: "#000"
    }
  }));
}

export function processAxisLabels(
  labels,
  max,
  chartWidth,
  fontSize: number = 12,
  rotation: number = 0,
  xMin: number = 0
) {
  const labelsToUse = [];
  let lastX = 0;
  let lastLabel = "";
  const visibleRange = max - xMin;
  if (visibleRange <= 0) return labels.slice(0, 1);

  const dataToChartRatio = visibleRange / chartWidth;

  // Only consider labels within the visible range
  const visibleLabels = labels.filter((l) => {
    const v = parseFloat(l.value);
    return v >= xMin && v <= max;
  });

  for (let i = 0; i < visibleLabels.length; i++) {
    const l = visibleLabels[i];
    const value = parseFloat(l.value);
    // Position relative to the visible range start so pixel calculations are correct
    const adjustedValue = value - xMin;

    if (i === 0) {
      labelsToUse.push(l);
      lastX = adjustedValue;
      lastLabel = l.label;
      continue;
    }

    const labelOverlapsOrIsOutOfBounds = checkForOverlappingAndOutOfBoundsLabels(
      dataToChartRatio,
      chartWidth,
      lastLabel,
      lastX,
      l.label,
      adjustedValue,
      fontSize,
      rotation
    );

    const x = adjustedValue - lastX;
    if (x / visibleRange > MOSAIC_LABEL_SPACING && !labelOverlapsOrIsOutOfBounds) {
      labelsToUse.push(l);
      lastX = adjustedValue;
      lastLabel = l.label;
    }
  }

  return labelsToUse;
}
